export const instrument_types = [
  { value: "BOND", label: "BOND" },
  { value: "CONVERTIBLE BOND", label: "CONVERTIBLE BOND" },
  { value: "EQUITY", label: "EQUITY" },
  { value: "FUND", label: "FUND" },
  { value: "DERIVATIVE", label: "DERIVATIVE" },
  { value: "LOAN", label: "LOAN" },
  { value: "PORTFOLIO", label: "PORTFOLIO" },
];
